import React from "react";
import { paths } from "./path";
import { Switch, Route } from "react-router-dom";
import RequestCancelMeeting from "../customerMeetings/landingPages/requestCancelMeeting/RequestCancelMeeting";
import JoinMeeting from "../customerMeetings/landingPages/joinMeeting/JoinMeeting";

export const Routes: React.FC<{}> = () => {
    return (
        <Switch>
            <Route path={paths.requestCancelMeeting} component={RequestCancelMeeting} />
            <Route path={paths.joinMeeting} component={JoinMeeting} />
        </Switch>
    );
};

export default Routes;
